import type { MouseEvent, SubmitEvent } from 'react'

const getDrawer = (id: string) => {
    const drawer = document.getElementById(id)

    if (!(drawer instanceof HTMLDialogElement)) {
        throw new Error(`No drawer with id "${id}"`)
    }

    return drawer
}

/** Tells the drawer to mount its children, before it opens for the first time */
export const DRAWER_OPEN_EVENT = 'drawer:open'

export const openDrawer = (id: string) => {
    const drawer = getDrawer(id)

    drawer.dispatchEvent(new Event(DRAWER_OPEN_EVENT))
    drawer.showModal()
}

export const closeDrawer = (id: string) => getDrawer(id).close()

export const closeOnBackdropOrLink = (evt: MouseEvent<HTMLDialogElement>) => {
    const drawer = evt.currentTarget
    const { target } = evt

    if (!(target instanceof Element)) {
        return
    }

    // A click on ::backdrop targets the dialog itself, a click in the panel
    // one of its children (this relies on the dialog having no padding).
    const isBackdropClick = target === drawer
    // Client-side navigation keeps the page, so close the drawer when a link
    // is followed. A link that opens a new window keeps you on this page.
    const isLinkClick = !!target.closest('a[href]:not([target="_blank"])')

    if (isBackdropClick || isLinkClick) {
        drawer.close()
    }
}

/**
 * Submit handler of the drawer's dialog. Closes the drawer when a form in it
 * is submitted, such as a search.
 */
export const closeOnSubmit = (evt: SubmitEvent<HTMLDialogElement>) => {
    evt.currentTarget.close()
}
